import { $, $$, isMobile } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-chip-close]')) return;

  isMobile.addEventListener('change', () => {
    addEventListeners();
  });

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-chip-close]').forEach((el) => {
    el.addEventListener('click', removeChip);
  });
}

function removeChip(e) {
  const el = e.currentTarget;
  // hide chip
  el.classList.add('au-hide');

  if (!el.closest('[data-au-chips-block]')) return;

  const titleText = el.closest('[data-au-chips-block]').querySelector('[data-au-chips-title]')
    ? `${el.closest('[data-au-chips-block]').querySelector('[data-au-chips-title]').innerText}_`
    : '';
  const clickText = el.querySelector(':not([data-au-icon])').innerText;
  const item_id = `${removeAccentMarkAndUppercase(titleText)}${removeAccentMarkAndUppercase(clickText)}_eliminar`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickBoton',
    item_id,
  });
}

export default { init };
